<template>
  <div class="box flex-stretch">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="exporting">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Exporting, please wait
        </div>
      </div>
    </div>
    <div class="box-content flex-stretch relative">
      <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8; z-index: 6; min-width: 400px; border-radius: 15px;" v-show="filtering"></div>
        <div class="flex justify-end mb-3">
          <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open, reports_menu_open = false" tabindex="1">
            <div class="multi-select-input-placeholder">
              Filter...
              <div class="dropdown-icon">
                <i class="fal fa-chevron-down"></i>
              </div>
            </div>
            <div class="multi-select-input-inner" v-show="filter_dropdown_open" @click.stop>
              <div class="multi-select-input-group">
                <h1 class="input-group-title">Date</h1>
                <div class="checkboxes">
                  <div class="">
                    <div class="input-group">
                      <div class="input-group-addon" style="width: 60px;">From:</div>
                      <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
                    </div>
                    <div class="input-group mt-1">
                      <div class="input-group-addon" style="width: 60px;">To:</div>
                      <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
                    </div>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">Company Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="company_type in all_company_types">
                    <label>
                      <input type="checkbox" name="company_types" :value="company_type.id" v-model="selected_company_types">
                      <span class="checkbox-label">{{ company_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="multi-select-input-group mt-3">
                <h1 class="input-group-title">System Types</h1>
                <div class="checkboxes">
                  <div class="checkbox level-1" v-for="system_type in all_epwin_system_types">
                    <label>
                      <input type="checkbox" name="system_types" :value="system_type.id" v-model="selected_system_types">
                      <span class="checkbox-label">{{ system_type.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ml-3">
            <a class="btn-primary" @click.stop.prevent="exportSpreadsheet()">
              Export
            </a>
          </div>
          <div class="ml-3">
            <reports-menu :menu_open="reports_menu_open" @open="reports_menu_open = true, filter_dropdown_open = false" @close="reports_menu_open = false"></reports-menu>
          </div>
        </div>
      <div id="reports-activations-table" class="google-table-wrapper flex-stretch"></div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  async mounted() {
    let lastYear = new Date();
    lastYear.setFullYear(lastYear.getFullYear() - 1);
    this.date_filter_start = lastYear;
    this.loadCompanyTypes();
    this.loadActivatedUserList();
    window.googleCharts.charts.load('current', {
      'packages': ['table']
    });
    this.loading = false;
  },
  props: [
      'all_company_types',
      'all_epwin_system_types'
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      filtering: false,
      date_filter_start: null,
      date_filter_end: new Date(),
      activated_user_list: [],
      loading: true,
      company_types: [],
      selected_company_types: [],
      system_types: [],
      selected_system_types: [],
      filter_dropdown_open: false,
      reports_menu_open: false,
      exporting: false,
    }
  },
  methods: {
    drawTable() {
      let data = new window.googleCharts.visualization.DataTable();
      let data_rows = [];
      let total_account_activations = 0;

      let company_type_total_activations = [];

      this.company_types.forEach(function(){
        company_type_total_activations.push(0);
      });

      Object.values(this.activated_user_list).forEach(function(activation_date) {
        let rows = [activation_date.date, activation_date.total_users];
        let company_type_data_rows = [];
        total_account_activations = total_account_activations + activation_date.total_users;
        activation_date.company_types.forEach(function(company_type, index) {
          company_type_data_rows.push(company_type.user_count);
        });
        company_type_total_activations = company_type_total_activations.map((count, index) => count + company_type_data_rows[index]);
        let all_rows = rows.concat(company_type_data_rows);
        data_rows.push(all_rows);
      });

      data.addColumn({type: 'string', label: 'Date', p: {className: 'date-column'}});
      data.addColumn('number', `Total Accounts Activated (${total_account_activations})`);

      this.company_types.forEach(function(company_type, index){
        data.addColumn('number', `${company_type.label} (${company_type_total_activations[index]})`);
      });

      data.addRows(data_rows);

      let table_wrapper = document.getElementById('reports-activations-table');
      let table_wrapper_height = table_wrapper.offsetHeight - 1;
      let table_wrapper_width = table_wrapper.offsetWidth - 1;
      let table = new window.googleCharts.visualization.Table(table_wrapper);
      table.draw(data, {showRowNumber: false, width: table_wrapper_width, height: table_wrapper_height, frozenColumns: 1,});
    },
    loadActivatedUserList: _.debounce(function () {
      axios.post('/reports/getActivatedUserListData', {
        selected_company_types: this.selected_company_types,
        selected_system_types: this.selected_system_types,
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
      }).then((response) => {
        this.activated_user_list = response.data;
        this.filtering = false;
        window.googleCharts.charts.setOnLoadCallback(this.drawTable);
      });
    }, 250),
    loadCompanyTypes: _.debounce(function () {
      axios.post('/reports/getCompanyTypes', {
        selected_company_types: this.selected_company_types,
      }).then((response) => {
        this.company_types = response.data;
      });
    }, 250),
    exportSpreadsheet() {
      this.exporting = true;
      axios({
        url: '/reports/export/account-activations',
        method: 'POST',
        responseType: 'blob',
        data: {
          selected_company_types: this.selected_company_types,
          selected_system_types: this.selected_system_types,
          date_filter_start: this.date_filter_start,
          date_filter_end: this.date_filter_end,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'reports_user_activations.xlsx');
        document.body.appendChild(link);
        link.click();
        this.exporting = false;
      });
    },
  },
  watch: {
    date_filter_start() {
      this.filtering = true;
      this.loadActivatedUserList();
    },
    date_filter_end() {
      this.filtering = true;
      this.loadActivatedUserList();
    },
    selected_company_types() {
      this.filtering = true;
      this.loadCompanyTypes();
      this.loadActivatedUserList();
    },
    selected_system_types() {
      this.filtering = true;
      this.loadActivatedUserList();
    },
  },
};
</script>